require('./ProgramSnippet.scss');

const b = require('app/www/libs/b')('program-snippet');

const React = require('react');
const PropTypes = require('prop-types');
const {withReq} = require('app/www/components/contexts/Req');

const Metrika = require('app/www/libs/client/metrika');

const Button_WannaSee = require('app/www/components/blocks/Button/_WannaSee/Button_WannaSee');
const Link = require('app/www/components/blocks/Link/Link');

class ProgramSnippet extends React.PureComponent {

    render() {
        const {
            event: {
                url,
                date,
                type,
                year,
                image,
                title,
                isNow,
                index,
                program,
                country,
                channels,
            },
            req,
            onClick,
            section,
            isTouchButtons,
        } = this.props;

        const urlBuilder = req.lib('urlBuilder');
        const hasMounted = typeof isTouchButtons !== 'undefined';
        const channelBroadcasting = isNow && channels.filter(channel => channel.hasBroadcasting)[0];
        const broadcasting = Boolean(channelBroadcasting);
        const styleProgramIcon = image ? {
            backgroundImage: `url('${image}')`,
        } : {};

        const mods = {broadcasting};
        const searchParams = {
            index,
            title,
            section,
            id: program.id,
        };

        if (hasMounted) {
            mods.buttons = isTouchButtons ? 'touch' : 'not-touch';
        }

        return (
            <div className={b(mods)}>
                <Link
                    className={b('link')}
                    url={url}
                    onClick={onClick(searchParams)}
                />
                <div className={b('wrapper')}>
                    <div className={b('image')} style={styleProgramIcon} />
                    <div className={b('info')}>
                        <div className={b('meta')}>
                            {[type, country, year].filter(Boolean).map(item => (
                                <i key={item} className={b('meta-item')}>{item}</i>
                            ))}
                        </div>
                        <div className={b('title')}>{title}</div>
                        <div className={b('event')}>
                            <i className={b('date', {now: isNow})}>
                                {date}
                            </i>
                            {channels.map(channel => [
                                <i key="dot" className={b('dot')}>•</i>,
                                <Link
                                    key="channel"
                                    className={b('channel-link')}
                                    url={urlBuilder.getChannelUrl(channel.transliteratedFamilyTitle)}
                                    onClick={this._onChannelClick(channel.familyId)}
                                >
                                    <i className={b('channel')}>{channel.title}</i>
                                </Link>,
                            ])}
                        </div>
                    </div>
                    {hasMounted && (
                        <div className={b('buttons')}>
                            {this._renderButtonWannaSee(program.id)}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    /**
     * @param {Number} programId
     * @returns {Object}
     * @private
     */
    _renderButtonWannaSee(programId) {
        const {isTouchButtons, onClickWannaSee} = this.props;

        const buttonWannaSeeProps = {
            mods: isTouchButtons ? {
                theme: 'clear',
                size: 'xl',
                'only-icon': true,
                touch: true,
            } : {
                theme: 'ghost',
                size: 's',
                pin: 'circle',
                icon: 'dim',
                'only-icon': true,
            },
            icon: {
                size: isTouchButtons ? 'm' : 's',
                'wanna-see': true,
            },
            programId,
            onClick: onClickWannaSee,
        };

        return <Button_WannaSee {...buttonWannaSeeProps} />;
    }

    /**
     * @private
     * @param {Number} channelId
     */
    _onChannelClick(channelId) {
        const {tabId} = this.props;

        return () => {
            Metrika.trackParams('CHANNEL_TITLE', {
                channelId,
                tabId,
            });
        };
    }
}

ProgramSnippet.defaultProps = {
    onClick: () => {},
};

ProgramSnippet.propTypes = {
    event: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    onClickWannaSee: PropTypes.func,
    isTouchButtons: PropTypes.bool,
};

module.exports = withReq(ProgramSnippet);

